import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ onAction }) => {
  const actions = [
    {
      id: 'recipe-suggestions',
      title: 'Recipe Suggestions',
      description: 'Get recipes based on your ingredients',
      icon: 'ChefHat',
      color: 'bg-orange-50 hover:bg-orange-100 border-orange-200',
      iconColor: 'text-orange-600'
    },
    {
      id: 'menu-planning',
      title: 'Menu Planning',
      description: 'Plan complete dinner party menus',
      icon: 'Calendar',
      color: 'bg-blue-50 hover:bg-blue-100 border-blue-200',
      iconColor: 'text-blue-600'
    },
    {
      id: 'shopping-list',
      title: 'Shopping Lists',
      description: 'Generate organized shopping lists',
      icon: 'ShoppingCart',
      color: 'bg-green-50 hover:bg-green-100 border-green-200',
      iconColor: 'text-green-600'
    },
    {
      id: 'dietary-advice',
      title: 'Dietary Advice',
      description: 'Get help with dietary restrictions',
      icon: 'Heart',
      color: 'bg-red-50 hover:bg-red-100 border-red-200',
      iconColor: 'text-red-600'
    },
    {
      id: 'wine-pairing',
      title: 'Wine Pairing',
      description: 'Find perfect wine matches',
      icon: 'Wine',
      color: 'bg-purple-50 hover:bg-purple-100 border-purple-200',
      iconColor: 'text-purple-600'
    },
    {
      id: 'cooking-tips',
      title: 'Cooking Tips',
      description: 'Expert cooking and hosting advice',
      icon: 'Lightbulb',
      color: 'bg-yellow-50 hover:bg-yellow-100 border-yellow-200',
      iconColor: 'text-yellow-600'
    }
  ];

  return (
    <div className="mb-8">
      <h2 className="text-lg font-semibold text-foreground mb-4">
        Quick Actions
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => onAction?.(action?.id)}
            className={`p-4 rounded-lg border-2 transition-all duration-200 text-left group ${action?.color}`}
          >
            <div className="flex items-start space-x-3">
              <div className={`w-10 h-10 rounded-lg bg-white/80 flex items-center justify-center group-hover:scale-110 transition-transform ${action?.iconColor}`}>
                <Icon name={action?.icon} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground mb-1">
                  {action?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {action?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;